import renderSVG from '@Controls/render-icon';
import React from 'react';
import FontIconPicker from '@fonticonpicker/react-fonticonpicker';
import WPSPBlockIcons from '@Controls/block-icons';

// Import all of our Text Options requirements.
import TypographyControl from '@Components/typography';
import { ColorPalette, InspectorControls } from '@wordpress/block-editor';
import {
	PanelBody,
	SelectControl,
	RangeControl,
	TabPanel,
	ButtonGroup,
	Button,
	Dashicon,
	ToggleControl,
	IconButton,
} from '@wordpress/components';
import { select } from '@wordpress/data';
import { __ } from '@wordpress/i18n';

const SvgIcons = Object.keys(wpsp_blocks_info.wpsp_icons);

const Settings = (props) => {
	props = props.parentProps;

	const { attributes, setAttributes } = props;
	const {
		layout,
		inactiveOtherItems,
		expandFirstItem,
		rowsGap,
		columnsGap,
		align,
		enableSeparator,
		boxBgColor,
		borderStyle,
		borderWidth,
		borderRadius,
		borderColor,
		questionTextColor,
		questionTextActiveColor,
		questionPaddingTypeDesktop,
		answerTextColor,
		answerPaddingTypeDesktop,
		vanswerPaddingMobile,
		vanswerPaddingTablet,
		vanswerPaddingDesktop,
		hanswerPaddingMobile,
		hanswerPaddingTablet,
		hanswerPaddingDesktop,
		iconColor,
		iconActiveColor,
		gapBtwIconQUestion,
		questionloadGoogleFonts,
		questionFontFamily,
		questionFontWeight,
		questionFontSubset,
		questionFontSizeType,
		questionFontSize,
		questionFontSizeMobile,
		questionFontSizeTablet,
		questionLineHeightType,
		questionLineHeight,
		questionLineHeightMobile,
		questionLineHeightTablet,
		answerloadGoogleFonts,
		answerFontFamily,
		answerFontWeight,
		answerFontSubset,
		answerFontSizeType,
		answerFontSize,
		answerFontSizeMobile,
		answerFontSizeTablet,
		answerLineHeightType,
		answerLineHeight,
		answerLineHeightMobile,
		answerLineHeightTablet,
		icon,
		iconActive,
		iconAlign,
		iconSizeType,
		iconSizeMobile,
		iconSizeTablet,
		iconSize,
		columns,
		tcolumns,
		mcolumns,
		enableToggle,
		equalHeight,
		questionLeftPaddingTablet,
		hquestionPaddingTablet,
		vquestionPaddingTablet,
		questionBottomPaddingTablet,
		questionLeftPaddingDesktop,
		hquestionPaddingDesktop,
		vquestionPaddingDesktop,
		questionBottomPaddingDesktop,
		questionLeftPaddingMobile,
		hquestionPaddingMobile,
		vquestionPaddingMobile,
		questionBottomPaddingMobile,
		headingTag,
	} = attributes;

	const onchangeIcon = (value) => {
		const getChildBlocks = select('core/block-editor').getBlocks(
			props.clientId
		);
		getChildBlocks.forEach((faqChild) => {
			faqChild.attributes.icon = value;
		});

		setAttributes({ icon: value });
	};
	const onchangeActiveIcon = (value) => {
		const getChildBlocks = select('core/block-editor').getBlocks(
			props.clientId
		);

		getChildBlocks.forEach((faqChild) => {
			faqChild.attributes.iconActive = value;
		});

		setAttributes({ iconActive: value });
	};
	const onchangeLayout = (value) => {
		const getChildBlocks = select('core/block-editor').getBlocks(
			props.clientId
		);

		getChildBlocks.forEach((faqChild) => {
			faqChild.attributes.layout = value;
		});

		setAttributes({ layout: value });
	};
	const onchangeTag = (value) => {
		const getChildBlocks = select('core/block-editor').getBlocks(
			props.clientId
		);

		getChildBlocks.forEach((faqChild) => {
			faqChild.attributes.headingTag = value;
		});
		setAttributes({ headingTag: value });
	};

	const faqGeneralSettings = () => {
		return (
			<PanelBody
				title={__('General')}
				initialOpen={true}
				className="wpsp__url-panel-body"
			>
				<SelectControl
					label={__('Layout')}
					value={layout}
					options={[
						{ value: 'accordion', label: __('Accordion') },
						{ value: 'grid', label: __('Grid') },
					]}
					onChange={(value) => onchangeLayout(value)}
				/>
				{'accordion' === layout && (
					<>
						<ToggleControl
							label={__('Collapse other items')}
							checked={inactiveOtherItems}
							onChange={() =>
								setAttributes({
									inactiveOtherItems: !inactiveOtherItems,
								})
							}
						/>
						{true === inactiveOtherItems && (
							<ToggleControl
								label={__('Expand First Item')}
								checked={expandFirstItem}
								onChange={() =>
									setAttributes({
										expandFirstItem: !expandFirstItem,
									})
								}
							/>
						)}
						<ToggleControl
							label={__('Enable Toggle')}
							checked={enableToggle}
							onChange={() =>
								setAttributes({
									enableToggle: !enableToggle,
								})
							}
						/>
					</>
				)}
				<hr className="wpsp-editor__separator" />
				{'grid' === layout && (
					<TabPanel
						className="wpsp-size-type-field-tabs wpsp-without-size-type"
						activeClass="active-tab"
						tabs={[
							{
								name: 'desktop',
								title: <Dashicon icon="desktop" />,
								className:
									'wpsp-desktop-tab wpsp-responsive-tabs',
							},
							{
								name: 'tablet',
								title: <Dashicon icon="tablet" />,
								className:
									'wpsp-tablet-tab wpsp-responsive-tabs',
							},
							{
								name: 'mobile',
								title: <Dashicon icon="smartphone" />,
								className:
									'wpsp-mobile-tab wpsp-responsive-tabs',
							},
						]}
					>
						{(tab) => {
							let tabout;

							if ('mobile' === tab.name) {
								tabout = (
									<RangeControl
										label={__('Mobile Columns')}
										value={mcolumns}
										onChange={(value) =>
											setAttributes({
												mcolumns: value,
											})
										}
										min={1}
										max={2}
									/>
								);
							} else if ('tablet' === tab.name) {
								tabout = (
									<RangeControl
										label={__('Tab Columns')}
										value={tcolumns}
										onChange={(value) =>
											setAttributes({
												tcolumns: value,
											})
										}
										min={1}
										max={4}
									/>
								);
							} else {
								tabout = (
									<RangeControl
										label={__('Desktop Columns')}
										value={columns}
										onChange={(value) =>
											setAttributes({
												columns: value,
											})
										}
										min={1}
										max={6}
									/>
								);
							}

							return <div>{tabout}</div>;
						}}
					</TabPanel>
				)}
				{'grid' === layout && (
					<>
						<h2> {__('Alignment')}</h2>
						<IconButton
							key={'left'}
							icon="editor-alignleft"
							label="Left"
							onClick={() => setAttributes({ align: 'left' })}
							aria-pressed={'left' === align}
							isPrimary={'left' === align}
						/>
						<IconButton
							key={'center'}
							icon="editor-aligncenter"
							label="Right"
							onClick={() => setAttributes({ align: 'center' })}
							aria-pressed={'center' === align}
							isPrimary={'center' === align}
						/>
						<IconButton
							key={'right'}
							icon="editor-alignright"
							label="Right"
							onClick={() => setAttributes({ align: 'right' })}
							aria-pressed={'right' === align}
							isPrimary={'right' === align}
						/>
					</>
				)}
				{'accordion' === layout && faqIconSettings()}
			</PanelBody>
		);
	};

	const faqStylingSettings = () => {
		return (
			<PanelBody
				title={__('Style')}
				initialOpen={false}
				className="wpsp__url-panel-body"
			>
				<p className="wpsp-setting-label">
					{__('Background Color')}
					<span className="components-base-control__label">
						<span
							className="-color-indicator"
							style={{ backgroundColor: boxBgColor }}
						></span>
					</span>
				</p>
				<ColorPalette
					value={boxBgColor}
					onChange={(value) => setAttributes({ boxBgColor: value })}
					allowReset
				/>
				<RangeControl
					label={__('Rows Gap (px)')}
					value={rowsGap}
					onChange={(value) => setAttributes({ rowsGap: value })}
					min={0}
					max={50}
				/>
				{'grid' === layout && (
					<>
						<RangeControl
							label={__('Columns Gap (px)')}
							value={columnsGap}
							onChange={(value) =>
								setAttributes({ columnsGap: value })
							}
							min={0}
							max={50}
						/>
						<ToggleControl
							label={__('Equal Height')}
							checked={equalHeight}
							onChange={() =>
								setAttributes({
									equalHeight: !equalHeight,
								})
							}
						/>
					</>
				)}
				<ToggleControl
					label={__('Enable Separator')}
					checked={enableSeparator}
					onChange={() =>
						setAttributes({
							enableSeparator: !enableSeparator,
						})
					}
				/>
				<hr className="wpsp-editor__separator" />
				<h2>{__('Border')}</h2>
				<SelectControl
					label={__('Style')}
					value={borderStyle}
					options={[
						{ value: 'none', label: __('None') },
						{ value: 'solid', label: __('Solid') },
						{ value: 'dotted', label: __('Dotted') },
						{ value: 'dashed', label: __('Dashed') },
						{ value: 'double', label: __('Double') },
					]}
					onChange={(value) => {
						setAttributes({ borderStyle: value });
					}}
				/>
				{'none' !== borderStyle && (
					<RangeControl
						label={__('Thickness (px)')}
						value={borderWidth}
						onChange={(value) => {
							setAttributes({ borderWidth: value });
						}}
						min={0}
						max={20}
					/>
				)}
				{'none' !== borderStyle && (
					<RangeControl
						label={__('Rounded Corners (px)')}
						value={borderRadius}
						onChange={(value) => {
							setAttributes({ borderRadius: value });
						}}
						min={0}
						max={50}
					/>
				)}
				<p className="wpsp-setting-label">
					{__('Color')}
					<span className="components-base-control__label">
						<span
							className="-color-indicator"
							style={{ backgroundColor: borderColor }}
						></span>
					</span>
				</p>
				<ColorPalette
					value={borderColor}
					onChange={(value) => setAttributes({ borderColor: value })}
					allowReset
				/>

				{'accordion' === layout && (
					<>
						<hr className="wpsp-editor__separator" />
						<h2>{__('Icon')}</h2>
						<TabPanel
							className="wpsp-size-type-field-tabs wpsp-size-type-field__common-tabs wpsp-inline-margin"
							activeClass="active-tab"
							tabs={[
								{
									name: 'desktop',
									title: <Dashicon icon="desktop" />,
									className:
										'wpsp-desktop-tab wpsp-responsive-tabs',
								},
								{
									name: 'tablet',
									title: <Dashicon icon="tablet" />,
									className:
										'wpsp-tablet-tab wpsp-responsive-tabs',
								},
								{
									name: 'mobile',
									title: <Dashicon icon="smartphone" />,
									className:
										'wpsp-mobile-tab wpsp-responsive-tabs',
								},
							]}
						>
							{(tab) => {
								let tabout;

								if ('mobile' === tab.name) {
									tabout = (
										<>
											<ButtonGroup
												className="wpsp-size-type-field"
												aria-label={__('Size Type')}
											>
												<Button
													key={'px'}
													className="wpsp-size-btn"
													isSmall
													isPrimary={
														iconSizeType === 'px'
													}
													aria-pressed={
														iconSizeType === 'px'
													}
													onClick={() =>
														setAttributes({
															iconSizeType: 'px',
														})
													}
												>
													{'px'}
												</Button>
												<Button
													key={'%'}
													className="wpsp-size-btn"
													isSmall
													isPrimary={
														iconSizeType === '%'
													}
													aria-pressed={
														iconSizeType === '%'
													}
													onClick={() =>
														setAttributes({
															iconSizeType: '%',
														})
													}
												>
													{'%'}
												</Button>
											</ButtonGroup>
											<h2>{__('Size')}</h2>
											<RangeControl
												value={iconSizeMobile}
												onChange={(value) =>
													setAttributes({
														iconSizeMobile: value,
													})
												}
												min={0}
												max={100}
												allowReset
											/>
										</>
									);
								} else if ('tablet' === tab.name) {
									tabout = (
										<>
											<ButtonGroup
												className="wpsp-size-type-field"
												aria-label={__('Size Type')}
											>
												<Button
													key={'px'}
													className="wpsp-size-btn"
													isSmall
													isPrimary={
														iconSizeType === 'px'
													}
													aria-pressed={
														iconSizeType === 'px'
													}
													onClick={() =>
														setAttributes({
															iconSizeType: 'px',
														})
													}
												>
													{'px'}
												</Button>
												<Button
													key={'%'}
													className="wpsp-size-btn"
													isSmall
													isPrimary={
														iconSizeType === '%'
													}
													aria-pressed={
														iconSizeType === '%'
													}
													onClick={() =>
														setAttributes({
															iconSizeType: '%',
														})
													}
												>
													{'%'}
												</Button>
											</ButtonGroup>
											<h2>{__('Size')}</h2>
											<RangeControl
												value={iconSizeTablet}
												onChange={(value) =>
													setAttributes({
														iconSizeTablet: value,
													})
												}
												min={0}
												max={100}
												allowReset
											/>
										</>
									);
								} else {
									tabout = (
										<>
											<ButtonGroup
												className="wpsp-size-type-field"
												aria-label={__('Size Type')}
											>
												<Button
													key={'px'}
													className="wpsp-size-btn"
													isSmall
													isPrimary={
														iconSizeType === 'px'
													}
													aria-pressed={
														iconSizeType === 'px'
													}
													onClick={() =>
														setAttributes({
															iconSizeType: 'px',
														})
													}
												>
													{'px'}
												</Button>
												<Button
													key={'%'}
													className="wpsp-size-btn"
													isSmall
													isPrimary={
														iconSizeType === '%'
													}
													aria-pressed={
														iconSizeType === '%'
													}
													onClick={() =>
														setAttributes({
															iconSizeType: '%',
														})
													}
												>
													{'%'}
												</Button>
											</ButtonGroup>
											<h2>{__('Size')}</h2>
											<RangeControl
												value={iconSize}
												onChange={(value) =>
													setAttributes({
														iconSize: value,
													})
												}
												min={0}
												max={100}
												allowReset
											/>
										</>
									);
								}

								return <div>{tabout}</div>;
							}}
						</TabPanel>
						<RangeControl
							label={__('Gap between Icon and Question')}
							value={gapBtwIconQUestion}
							onChange={(value) =>
								setAttributes({
									gapBtwIconQUestion: value,
								})
							}
							min={0}
							max={100}
						/>
						<p className="wpsp-setting-label">
							{__('Expand Color')}
							<span className="components-base-control__label">
								<span
									className="-color-indicator"
									style={{ backgroundColor: iconColor }}
								></span>
							</span>
						</p>
						<ColorPalette
							value={iconColor}
							onChange={(value) =>
								setAttributes({ iconColor: value })
							}
							allowReset
						/>
						<p className="wpsp-setting-label">
							{__('Collapse Color')}
							<span className="components-base-control__label">
								<span
									className="-color-indicator"
									style={{
										backgroundColor: iconActiveColor,
									}}
								></span>
							</span>
						</p>
						<ColorPalette
							value={iconActiveColor}
							onChange={(value) =>
								setAttributes({ iconActiveColor: value })
							}
							allowReset
						/>
					</>
				)}
			</PanelBody>
		);
	};
	const faqIconSettings = () => {
		return (
			<>
				<h2> {__('Icon')} </h2>
				<p className="components-base-control__label">{__('Expand')}</p>
				<FontIconPicker
					icons={SvgIcons}
					renderFunc={renderSVG}
					theme="default"
					value={icon}
					onChange={(value) => onchangeIcon(value)}
					isMulti={false}
					noSelectedPlaceholder={__('Select Icon')}
				/>
				<p className="components-base-control__label">
					{__('Collapse')}
				</p>
				<FontIconPicker
					icons={SvgIcons}
					renderFunc={renderSVG}
					theme="default"
					value={iconActive}
					onChange={(value) => onchangeActiveIcon(value)}
					isMulti={false}
					noSelectedPlaceholder={__('Select Icon')}
				/>
				<h2> {__('Icon Alignment')}</h2>
				<IconButton
					key={'row'}
					icon="editor-alignleft"
					label="Left"
					onClick={() => setAttributes({ iconAlign: 'row' })}
					aria-pressed={'row' === iconAlign}
					isPrimary={'row' === iconAlign}
				/>
				<IconButton
					key={'row-reverse'}
					icon="editor-alignright"
					label="Right"
					onClick={() => setAttributes({ iconAlign: 'row-reverse' })}
					aria-pressed={'row-reverse' === iconAlign}
					isPrimary={'row-reverse' === iconAlign}
				/>
			</>
		);
	};
	const faqQuestionSettings = () => {
		return (
			<PanelBody
				title={__('Question')}
				initialOpen={false}
				className="wpsp__url-panel-body"
			>
				<SelectControl
					label={__('Question Tag')}
					value={headingTag}
					onChange={(value) => onchangeTag(value)}
					options={[
						{ value: 'span', label: __('Span') },
						{ value: 'p', label: __('P') },
						{ value: 'h1', label: __('H1') },
						{ value: 'h2', label: __('H2') },
						{ value: 'h3', label: __('H3') },
						{ value: 'h4', label: __('H4') },
						{ value: 'h5', label: __('H5') },
						{ value: 'h6', label: __('H6') },
					]}
				/>
				<TypographyControl
					label={__('Typography')}
					attributes={attributes}
					setAttributes={setAttributes}
					loadGoogleFonts={{
						value: questionloadGoogleFonts,
						label: 'questionloadGoogleFonts',
					}}
					fontFamily={{
						value: questionFontFamily,
						label: 'questionFontFamily',
					}}
					fontWeight={{
						value: questionFontWeight,
						label: 'questionFontWeight',
					}}
					fontSubset={{
						value: questionFontSubset,
						label: 'questionFontSubset',
					}}
					fontSizeType={{
						value: questionFontSizeType,
						label: 'questionFontSizeType',
					}}
					fontSize={{
						value: questionFontSize,
						label: 'questionFontSize',
					}}
					fontSizeMobile={{
						value: questionFontSizeMobile,
						label: 'questionFontSizeMobile',
					}}
					fontSizeTablet={{
						value: questionFontSizeTablet,
						label: 'questionFontSizeTablet',
					}}
					lineHeightType={{
						value: questionLineHeightType,
						label: 'questionLineHeightType',
					}}
					lineHeight={{
						value: questionLineHeight,
						label: 'questionLineHeight',
					}}
					lineHeightMobile={{
						value: questionLineHeightMobile,
						label: 'questionLineHeightMobile',
					}}
					lineHeightTablet={{
						value: questionLineHeightTablet,
						label: 'questionLineHeightTablet',
					}}
				/>
				<p className="wpsp-setting-label">
					{__('Text Color')}
					<span className="components-base-control__label">
						<span
							className="-color-indicator"
							style={{ backgroundColor: questionTextColor }}
						></span>
					</span>
				</p>
				<ColorPalette
					value={questionTextColor}
					onChange={(value) =>
						setAttributes({ questionTextColor: value })
					}
					allowReset
				/>
				{'accordion' === layout && (
					<p className="wpsp-setting-label">
						{__('Text Active/Hover Color')}
						<span className="components-base-control__label">
							<span
								className="-color-indicator"
								style={{
									backgroundColor: questionTextActiveColor,
								}}
							></span>
						</span>
					</p>
				)}
				{'grid' === layout && (
					<p className="wpsp-setting-label">
						{__('Text Hover Color')}
						<span className="components-base-control__label">
							<span
								className="-color-indicator"
								style={{
									backgroundColor: questionTextActiveColor,
								}}
							></span>
						</span>
					</p>
				)}
				<ColorPalette
					value={questionTextActiveColor}
					onChange={(value) =>
						setAttributes({ questionTextActiveColor: value })
					}
					allowReset
				/>
				<TabPanel
					className="wpsp-size-type-field-tabs wpsp-size-type-field__common-tabs wpsp-inline-margin"
					activeClass="active-tab"
					tabs={[
						{
							name: 'desktop',
							title: <Dashicon icon="desktop" />,
							className: 'wpsp-desktop-tab wpsp-responsive-tabs',
						},
						{
							name: 'tablet',
							title: <Dashicon icon="tablet" />,
							className: 'wpsp-tablet-tab wpsp-responsive-tabs',
						},
						{
							name: 'mobile',
							title: <Dashicon icon="smartphone" />,
							className: 'wpsp-mobile-tab wpsp-responsive-tabs',
						},
					]}
				>
					{(tab) => {
						let tabout;

						if ('mobile' === tab.name) {
							tabout = (
								<>
									<ButtonGroup
										className="wpsp-size-type-field"
										aria-label={__('Size Type')}
									>
										<Button
											key={'px'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												questionPaddingTypeDesktop ===
												'px'
											}
											aria-pressed={
												questionPaddingTypeDesktop ===
												'px'
											}
											onClick={() =>
												setAttributes({
													questionPaddingTypeDesktop:
														'px',
												})
											}
										>
											{'px'}
										</Button>
										<Button
											key={'%'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												questionPaddingTypeDesktop ===
												'%'
											}
											aria-pressed={
												questionPaddingTypeDesktop ===
												'%'
											}
											onClick={() =>
												setAttributes({
													questionPaddingTypeDesktop:
														'%',
												})
											}
										>
											{'%'}
										</Button>
									</ButtonGroup>
									<h2>{__('Padding')}</h2>
									<RangeControl
										label={WPSPBlockIcons.left_margin}
										className={'wpsp-margin-control'}
										value={questionLeftPaddingMobile}
										onChange={(value) =>
											setAttributes({
												questionLeftPaddingMobile:
													value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.right_margin}
										className={'wpsp-margin-control'}
										value={hquestionPaddingMobile}
										onChange={(value) =>
											setAttributes({
												hquestionPaddingMobile: value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.top_margin}
										className={'wpsp-margin-control'}
										value={vquestionPaddingMobile}
										onChange={(value) =>
											setAttributes({
												vquestionPaddingMobile: value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.bottom_margin}
										className={'wpsp-margin-control'}
										value={questionBottomPaddingMobile}
										onChange={(value) =>
											setAttributes({
												questionBottomPaddingMobile:
													value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
								</>
							);
						} else if ('tablet' === tab.name) {
							tabout = (
								<>
									<ButtonGroup
										className="wpsp-size-type-field"
										aria-label={__('Size Type')}
									>
										<Button
											key={'px'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												questionPaddingTypeDesktop ===
												'px'
											}
											aria-pressed={
												questionPaddingTypeDesktop ===
												'px'
											}
											onClick={() =>
												setAttributes({
													questionPaddingTypeDesktop:
														'px',
												})
											}
										>
											{'px'}
										</Button>
										<Button
											key={'%'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												questionPaddingTypeDesktop ===
												'%'
											}
											aria-pressed={
												questionPaddingTypeDesktop ===
												'%'
											}
											onClick={() =>
												setAttributes({
													questionPaddingTypeDesktop:
														'%',
												})
											}
										>
											{'%'}
										</Button>
									</ButtonGroup>
									<h2>{__('Padding')}</h2>
									<RangeControl
										label={WPSPBlockIcons.left_margin}
										className={'wpsp-margin-control'}
										value={questionLeftPaddingTablet}
										onChange={(value) =>
											setAttributes({
												questionLeftPaddingTablet:
													value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.right_margin}
										className={'wpsp-margin-control'}
										value={hquestionPaddingTablet}
										onChange={(value) =>
											setAttributes({
												hquestionPaddingTablet: value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.top_margin}
										className={'wpsp-margin-control'}
										value={vquestionPaddingTablet}
										onChange={(value) =>
											setAttributes({
												vquestionPaddingTablet: value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.bottom_margin}
										className={'wpsp-margin-control'}
										value={questionBottomPaddingTablet}
										onChange={(value) =>
											setAttributes({
												questionBottomPaddingTablet:
													value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
								</>
							);
						} else {
							tabout = (
								<>
									<ButtonGroup
										className="wpsp-size-type-field"
										aria-label={__('Size Type')}
									>
										<Button
											key={'px'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												questionPaddingTypeDesktop ===
												'px'
											}
											aria-pressed={
												questionPaddingTypeDesktop ===
												'px'
											}
											onClick={() =>
												setAttributes({
													questionPaddingTypeDesktop:
														'px',
												})
											}
										>
											{'px'}
										</Button>
										<Button
											key={'%'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												questionPaddingTypeDesktop ===
												'%'
											}
											aria-pressed={
												questionPaddingTypeDesktop ===
												'%'
											}
											onClick={() =>
												setAttributes({
													questionPaddingTypeDesktop:
														'%',
												})
											}
										>
											{'%'}
										</Button>
									</ButtonGroup>
									<h2>{__('Padding')}</h2>
									<RangeControl
										label={WPSPBlockIcons.left_margin}
										className={'wpsp-margin-control'}
										value={questionLeftPaddingDesktop}
										onChange={(value) =>
											setAttributes({
												questionLeftPaddingDesktop:
													value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.right_margin}
										className={'wpsp-margin-control'}
										value={hquestionPaddingDesktop}
										onChange={(value) =>
											setAttributes({
												hquestionPaddingDesktop: value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.top_margin}
										className={'wpsp-margin-control'}
										value={vquestionPaddingDesktop}
										onChange={(value) =>
											setAttributes({
												vquestionPaddingDesktop: value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
									<RangeControl
										label={WPSPBlockIcons.bottom_margin}
										className={'wpsp-margin-control'}
										value={questionBottomPaddingDesktop}
										onChange={(value) =>
											setAttributes({
												questionBottomPaddingDesktop:
													value,
											})
										}
										min={0}
										max={50}
										allowReset
									/>
								</>
							);
						}

						return <div>{tabout}</div>;
					}}
				</TabPanel>
			</PanelBody>
		);
	};
	const faqAnswerSettings = () => {
		return (
			<PanelBody
				title={__('Answer')}
				initialOpen={false}
				className="wpsp__url-panel-body"
			>
				<TypographyControl
					label={__('Typography')}
					attributes={attributes}
					setAttributes={setAttributes}
					loadGoogleFonts={{
						value: answerloadGoogleFonts,
						label: 'answerloadGoogleFonts',
					}}
					fontFamily={{
						value: answerFontFamily,
						label: 'answerFontFamily',
					}}
					fontWeight={{
						value: answerFontWeight,
						label: 'answerFontWeight',
					}}
					fontSubset={{
						value: answerFontSubset,
						label: 'answerFontSubset',
					}}
					fontSizeType={{
						value: answerFontSizeType,
						label: 'answerFontSizeType',
					}}
					fontSize={{
						value: answerFontSize,
						label: 'answerFontSize',
					}}
					fontSizeMobile={{
						value: answerFontSizeMobile,
						label: 'answerFontSizeMobile',
					}}
					fontSizeTablet={{
						value: answerFontSizeTablet,
						label: 'answerFontSizeTablet',
					}}
					lineHeightType={{
						value: answerLineHeightType,
						label: 'answerLineHeightType',
					}}
					lineHeight={{
						value: answerLineHeight,
						label: 'answerLineHeight',
					}}
					lineHeightMobile={{
						value: answerLineHeightMobile,
						label: 'answerLineHeightMobile',
					}}
					lineHeightTablet={{
						value: answerLineHeightTablet,
						label: 'answerLineHeightTablet',
					}}
				/>
				<p className="wpsp-setting-label">
					{__('Text Color')}
					<span className="components-base-control__label">
						<span
							className="-color-indicator"
							style={{ backgroundColor: answerTextColor }}
						></span>
					</span>
				</p>
				<ColorPalette
					value={answerTextColor}
					onChange={(value) =>
						setAttributes({ answerTextColor: value })
					}
					allowReset
				/>
				<TabPanel
					className="wpsp-size-type-field-tabs wpsp-size-type-field__common-tabs wpsp-inline-margin"
					activeClass="active-tab"
					tabs={[
						{
							name: 'desktop',
							title: <Dashicon icon="desktop" />,
							className: 'wpsp-desktop-tab wpsp-responsive-tabs',
						},
						{
							name: 'tablet',
							title: <Dashicon icon="tablet" />,
							className: 'wpsp-tablet-tab wpsp-responsive-tabs',
						},
						{
							name: 'mobile',
							title: <Dashicon icon="smartphone" />,
							className: 'wpsp-mobile-tab wpsp-responsive-tabs',
						},
					]}
				>
					{(tab) => {
						let tabout;

						if ('mobile' === tab.name) {
							tabout = (
								<>
									<ButtonGroup
										className="wpsp-size-type-field"
										aria-label={__('Size Type')}
									>
										<Button
											key={'px'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												answerPaddingTypeDesktop ===
												'px'
											}
											aria-pressed={
												answerPaddingTypeDesktop ===
												'px'
											}
											onClick={() =>
												setAttributes({
													answerPaddingTypeDesktop:
														'px',
												})
											}
										>
											{'px'}
										</Button>
										<Button
											key={'%'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												answerPaddingTypeDesktop === '%'
											}
											aria-pressed={
												answerPaddingTypeDesktop === '%'
											}
											onClick={() =>
												setAttributes({
													answerPaddingTypeDesktop:
														'%',
												})
											}
										>
											{'%'}
										</Button>
									</ButtonGroup>
									<h2>{__('Padding')}</h2>
									<RangeControl
										label={WPSPBlockIcons.vertical_spacing}
										className={'wpsp-margin-control'}
										value={vanswerPaddingMobile}
										onChange={(value) =>
											setAttributes({
												vanswerPaddingMobile: value,
											})
										}
										min={0}
										max={100}
										allowReset
									/>
									<RangeControl
										label={
											WPSPBlockIcons.horizontal_spacing
										}
										className={'wpsp-margin-control'}
										value={hanswerPaddingMobile}
										onChange={(value) =>
											setAttributes({
												hanswerPaddingMobile: value,
											})
										}
										min={0}
										max={100}
										allowReset
									/>
								</>
							);
						} else if ('tablet' === tab.name) {
							tabout = (
								<>
									<ButtonGroup
										className="wpsp-size-type-field"
										aria-label={__('Size Type')}
									>
										<Button
											key={'px'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												answerPaddingTypeDesktop ===
												'px'
											}
											aria-pressed={
												answerPaddingTypeDesktop ===
												'px'
											}
											onClick={() =>
												setAttributes({
													answerPaddingTypeDesktop:
														'px',
												})
											}
										>
											{'px'}
										</Button>
										<Button
											key={'%'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												answerPaddingTypeDesktop === '%'
											}
											aria-pressed={
												answerPaddingTypeDesktop === '%'
											}
											onClick={() =>
												setAttributes({
													answerPaddingTypeDesktop:
														'%',
												})
											}
										>
											{'%'}
										</Button>
									</ButtonGroup>
									<h2>{__('Padding')}</h2>
									<RangeControl
										label={WPSPBlockIcons.vertical_spacing}
										className={'wpsp-margin-control'}
										value={vanswerPaddingTablet}
										onChange={(value) =>
											setAttributes({
												vanswerPaddingTablet: value,
											})
										}
										min={0}
										max={100}
										allowReset
									/>
									<RangeControl
										label={
											WPSPBlockIcons.horizontal_spacing
										}
										className={'wpsp-margin-control'}
										value={hanswerPaddingTablet}
										onChange={(value) =>
											setAttributes({
												hanswerPaddingTablet: value,
											})
										}
										min={0}
										max={100}
										allowReset
									/>
								</>
							);
						} else {
							tabout = (
								<>
									<ButtonGroup
										className="wpsp-size-type-field"
										aria-label={__('Size Type')}
									>
										<Button
											key={'px'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												answerPaddingTypeDesktop ===
												'px'
											}
											aria-pressed={
												answerPaddingTypeDesktop ===
												'px'
											}
											onClick={() =>
												setAttributes({
													answerPaddingTypeDesktop:
														'px',
												})
											}
										>
											{'px'}
										</Button>
										<Button
											key={'%'}
											className="wpsp-size-btn"
											isSmall
											isPrimary={
												answerPaddingTypeDesktop === '%'
											}
											aria-pressed={
												answerPaddingTypeDesktop === '%'
											}
											onClick={() =>
												setAttributes({
													answerPaddingTypeDesktop:
														'%',
												})
											}
										>
											{'%'}
										</Button>
									</ButtonGroup>
									<h2>{__('Padding')}</h2>
									<RangeControl
										label={WPSPBlockIcons.vertical_spacing}
										className={'wpsp-margin-control'}
										value={vanswerPaddingDesktop}
										onChange={(value) =>
											setAttributes({
												vanswerPaddingDesktop: value,
											})
										}
										min={0}
										max={100}
										allowReset
									/>
									<RangeControl
										label={
											WPSPBlockIcons.horizontal_spacing
										}
										className={'wpsp-margin-control'}
										value={hanswerPaddingDesktop}
										onChange={(value) =>
											setAttributes({
												hanswerPaddingDesktop: value,
											})
										}
										min={0}
										max={100}
										allowReset
									/>
								</>
							);
						}

						return <div>{tabout}</div>;
					}}
				</TabPanel>
			</PanelBody>
		);
	};
	return (
		<>
			<InspectorControls>
				{faqGeneralSettings()}
				{faqStylingSettings()}
				{faqQuestionSettings()}
				{faqAnswerSettings()}
			</InspectorControls>
		</>
	);
};
export default React.memo(Settings);
